import { Icon, Text, XStack, YStack } from '@frontend/web-react';
import { safeCss } from '@frontend/web-utils';
import { router } from '@frontend/web/router';

type LowBandwidthHomeBannerProps = {
  dismiss: () => void;
  shouldShowBanner: boolean;
};

export const LowBandwidthHomeBanner = ({ dismiss, shouldShowBanner }: LowBandwidthHomeBannerProps) => {
  if (!shouldShowBanner) return null;

  const handleClick = () => {
    dismiss();
    router.navigate({ to: '/app/profile' });
  };

  const handleDismiss = (e: React.MouseEvent) => {
    e.stopPropagation();
    dismiss();
  };

  return (
    <XStack
      className={safeCss(
        'bg-blue-100 px-md py-md items-center gap-md cursor-pointer fixed bottom-none right-none z-50',
      )}
      onClick={handleClick}
      style={{ left: 'var(--app-shell-navbar-width, 0px)' }}
    >
      <YStack className="flex-1">
        <Text isSelectable={false} type="h6">
          You&apos;re running low on bandwidth.
        </Text>
        <Text isSelectable={false} type="p-sm">
          Click to upgrade
        </Text>
      </YStack>
      <XStack className="p-xs cursor-pointer" onClick={handleDismiss}>
        <Icon name="IconX" size={20} />
      </XStack>
    </XStack>
  );
};
